import dayjs from 'dayjs';
import { ITireModel } from 'app/shared/model/tire-model.model';
import { ITireTreadModel } from 'app/shared/model/tire-tread-model.model';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { ICompany } from 'app/shared/model/company.model';
import { TireState } from 'app/shared/model/enumerations/tire-state.model';
import { TireStatus } from 'app/shared/model/enumerations/tire-status.model';
import { TireFunction } from 'app/shared/model/enumerations/tire-function.model';
import { TireDiscardReason } from 'app/shared/model/enumerations/tire-discard-reason.model';

export interface ITire {
  id?: number;
  created?: string | null;
  updated?: string | null;
  discarded?: string | null;
  operational?: boolean | null;
  marking?: string | null;
  dot?: string | null;
  state?: TireState | null;
  status?: TireStatus | null;
  function?: TireFunction | null;
  initialGroove?: number | null;
  recap?: number | null;
  groove?: number | null;
  odometer?: number | null;
  performance?: number | null;
  lifeExpectancy?: number | null;
  lifePercent?: number | null;
  cpk?: number | null;
  totalCost?: number | null;
  discardCost?: number | null;
  discardReason?: TireDiscardReason | null;
  tireModel?: ITireModel | null;
  tireTreadModel?: ITireTreadModel | null;
  truckImplement?: ITruckImplement | null;
  company?: ICompany | null;
}

export type TireFormData = Omit<Partial<ITire>, 'groove' | 'odometer' | 'totalCost'> & {
  groove?: string | null;
  odometer?: string | null;
  totalCost?: string | null;
};

export const defaultValue: Readonly<ITire> = {
  operational: false,
};
